import { render, staticRenderFns } from "./ResourcePoolQuotas.vue?vue&type=template&id=26ff8230&scoped=true&"
import script from "./ResourcePoolQuotas.vue?vue&type=script&lang=js&"
export * from "./ResourcePoolQuotas.vue?vue&type=script&lang=js&"
import style0 from "./ResourcePoolQuotas.vue?vue&type=style&index=0&id=26ff8230&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ff8230",
  null
  
)

export default component.exports